import { DisableClickContext } from '~/contexts/DisableClickContext/DisableClickContext';
import { isFunction } from 'lodash';
import { useContext } from 'react';
import * as React from 'react';
import styled from 'styled-components';

const Link = (props) => {
  const { disabled } = useContext(DisableClickContext);
  const { children, onClick, href, target = '_blank', ...restProps } = props;

  const handleClick = (e) => {
    e.stopPropagation();
    isFunction(onClick) && onClick(e);
  };

  // eslint-disable-next-line no-script-url
  return disabled || href.startsWith('script:') || href.startsWith('javascript:') ? (
    <span {...restProps}>{children || href}</span>
  ) : (
    <StyledAnchor
      {...restProps}
      onClick={handleClick}
      href={href}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      target={target}
    >
      {children || href}
    </StyledAnchor>
  );
};

const StyledAnchor = styled.a`
  color: #125de6;
  text-decoration: none;
`;

export default React.memo(Link);
